export enum UserRole {
  ROLE_ADMIN = "ROLE_ADMIN",
  ROLE_SALESMAN = "ROLE_SALESMAN",
  ROLE_CUSTOMER = "ROLE_CUSTOMER",
}



// WEBPACK FOOTER //
// ./src/Models/EnumTypes/UserEnumTypes.ts